var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 4.226c-6.71 0-12.15 5.44-12.15 12.15 0 3.243 1.27 6.19 3.34 8.368.01-.131.032-.264.069-.398.964-3.5 4.512-4.97 8.741-4.97 4.23 0 7.777 1.47 8.741 4.97.037.134.06.267.068.398a12.109 12.109 0 0 0 3.341-8.368c0-6.71-5.44-12.15-12.15-12.15ZM2.65 16.376c0-7.649 6.2-13.85 13.85-13.85 7.65 0 13.85 6.201 13.85 13.85 0 7.65-6.2 13.85-13.85 13.85-7.65 0-13.85-6.2-13.85-13.85Zm13.85 2a5 5 0 1 0 0-10 5 5 0 0 0 0 10Z"
  })));
};
export default SvgUser;